import {
  PLAYBOOK_REGISTRY,
  PlaybookTemplate,
  getPlaybookBySlug,
} from "@/lib/learn/playbookRegistry";

// Personalisation hook kept on the API surface for future use — currently
// playbooks are pre-rendered branded PDFs in public/collateral/playbooks/,
// so this argument is accepted and ignored. When we wire up per-Genie
// personalisation, this is the seam.
export interface PlaybookPersonalisation {
  recipientName?: string;
  primaryGenieName?: string;
  primaryColor?: string;
  accentColor?: string;
}

export class PlaybookService {
  static listPlaybooks(): PlaybookTemplate[] {
    return [...PLAYBOOK_REGISTRY];
  }

  static getBySlug(slug: string): PlaybookTemplate | null {
    return getPlaybookBySlug(slug);
  }

  // Fetches the static PDF bytes for a playbook. Returns null if the
  // playbook or its underlying artifact can't be resolved.
  static async generate(
    slug: string,
    _personalisation: PlaybookPersonalisation = {},
  ): Promise<Blob | null> {
    const playbook = getPlaybookBySlug(slug);
    if (!playbook) return null;
    try {
      const res = await fetch(playbook.staticPdfUrl);
      if (!res.ok) return null;
      return await res.blob();
    } catch (err) {
      console.error("[PlaybookService] failed to fetch playbook PDF:", err);
      return null;
    }
  }

  // Triggers a browser download of the playbook PDF.
  static async download(
    slug: string,
    personalisation: PlaybookPersonalisation = {},
  ): Promise<boolean> {
    const blob = await PlaybookService.generate(slug, personalisation);
    if (!blob) return false;
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${slug}-playbook.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 1500);
    return true;
  }
}
